// // Helper function to handle converting different LaTeX content to MathML format
export const convertLatexContent = (latex: string): string => {
  let mathML = latex

  // Handle simple variables and symbols (e.g., a, b, x, y)
  mathML = mathML.replace(/([a-zA-Z0-9]+)(?![\^0-9])/g, (match, symbol) => {
    return `<mi>${symbol}</mi>`
  })

  // Handle numbers (e.g., 2, 3, 4)
  mathML = mathML.replace(/(\d+)/g, (match, number) => {
    return `<mn>${number}</mn>`
  })

  // Handle operators (e.g., +, -, *, /, =)
  mathML = mathML.replace(/([+\-*/=])/g, (match, operator) => {
    return `<mo>${operator}</mo>`
  })

  return latex
}

export function sanitizedMarkeupContent(text: string): string {
  return text.replace(/\*\*(.+?)\*\*/g, (match, p1) => `<b>${p1}</b>`)
}
